import React from 'react';
import { Routes, Route, Link as RouterLink } from 'react-router-dom';
import { 
  Typography, 
  Container, 
  Box,
  Link
} from '@mui/material';
import MainNavigation from './components/MainNavigation';
import Home from './Home';
import Guide from './pages/Guide';
import FAQ from './pages/FAQ';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import NotFound from './pages/NotFound';
import ErrorBoundary from './components/ErrorBoundary';
import SEOHead from './components/SEOHead';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

const theme = createTheme({
  palette: {
    primary: {
      main: '#388e3c', // A modern green
    },
    secondary: {
      main: '#f57c00', // A complementary orange
    },
  },
  typography: {
    fontFamily: 'Roboto, sans-serif',
  },
});



function Footer() {
  return (
    <Box 
      component="footer" 
      sx={{ 
        py: 4, 
        px: 2, 
        mt: 'auto', 
        background: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(10px)',
        borderTop: '1px solid rgba(255, 255, 255, 0.2)',
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 3, mb: 2 }}>
          <Link 
            component={RouterLink} 
            to="/about" 
            sx={{ 
              color: 'rgba(255, 255, 255, 0.9)',
              textDecoration: 'none',
              fontSize: '0.9rem',
              '&:hover': {
                color: 'white',
                textDecoration: 'underline'
              }
            }}
          >
            O aplikaci
          </Link>
          <Link 
            component={RouterLink} 
            to="/contact" 
            sx={{ 
              color: 'rgba(255, 255, 255, 0.9)',
              textDecoration: 'none',
              fontSize: '0.9rem',
              '&:hover': {
                color: 'white',
                textDecoration: 'underline'
              }
            }}
          >
            Kontakt
          </Link>
          <Link 
            component={RouterLink} 
            to="/terms" 
            sx={{ 
              color: 'rgba(255, 255, 255, 0.9)',
              textDecoration: 'none',
              fontSize: '0.9rem',
              '&:hover': {
                color: 'white',
                textDecoration: 'underline'
              }
            }}
          >
            Podmínky používání
          </Link>
          <Link 
            component={RouterLink} 
            to="/privacy" 
            sx={{ 
              color: 'rgba(255, 255, 255, 0.9)',
              textDecoration: 'none',
              fontSize: '0.9rem',
              '&:hover': {
                color: 'white',
                textDecoration: 'underline'
              }
            }}
          >
            Ochrana osobních údajů
          </Link>
        </Box>
        <Typography variant="body2" align="center" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
          {'© '}
          {new Date().getFullYear()}
          {' Nechci Lepek'}
        </Typography>
      </Container>
    </Box>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        }}
      >
        <MainNavigation />
        <Container component="main" maxWidth="lg" sx={{ mt: 2, mb: 4, flexGrow: 1 }}>
          <ErrorBoundary>
            <SEOHead />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/scan" element={<Home />} />
              <Route path="/guide" element={<Guide />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/404" element={<NotFound />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </ErrorBoundary>
        </Container>
        <Footer />
      </Box>
    </ThemeProvider>
  );
}

export default App; 